import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { aiConversationActions } from '../../actions';
import {
  FetchMessagesActionPayload,
  FillMessagesActionPayload,
} from '../../typedefs';

export function* fetchMessages({
  payload,
}: PayloadAction<FetchMessagesActionPayload>) {
  try {
    yield effects.put(aiConversationActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      {
        endpoint: `aiconversation/sessions/${payload.sessionId}/messages`,
        unsafe: true,
        query: payload.isLive && `reverse=${payload.isLive}`,
      },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    const data: FillMessagesActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(
      aiConversationActions.fillMessages({
        data,
        sessionId: payload.sessionId,
      }),
    );
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(aiConversationActions.stopFetching());
  }
}
